/* Balmohk · carruseles de la ficha: <bm-recommendations> («Te puede interesar») y
   <bm-recently-viewed> («Vistos recientemente»). Las cards las dibuja Liquid (snippets/bm-product-card). */
(function () {
  const STORAGE_KEY = 'bm:recently-viewed';

  /* Flechas de la foto de la card (snippets/bm-product-card, view 'sku' o arrows): alternan entre las dos fotos.
     Las carga también el listado (sections/bm-collection), que suma el swipe de abajo */
  if (!window.bmCardSteps) {
    window.bmCardSteps = true;
    document.addEventListener('click', (event) => {
      const step = event.target instanceof Element ? event.target.closest('[data-bm-card-step]') : null;
      const card = step?.closest('.bm-card');
      if (!card) return;
      const hovering = card.matches(':hover');
      const showing = card.dataset.bmPhoto || (hovering ? '2' : '1');
      card.dataset.bmPhoto = showing === '2' ? '1' : '2';
    });
    document.addEventListener('mouseout', (event) => {
      const card = event.target instanceof Element ? event.target.closest('.bm-card[data-bm-photo]') : null;
      if (card && !(event.relatedTarget instanceof Node && card.contains(event.relatedTarget))) {
        delete card.dataset.bmPhoto;
      }
    });

    /* Swipe de la foto (data-bm-card-swipe: la grilla del listado, pedido de Ro 23/10): deslizar con el dedo hacia la
       izquierda pasa a la segunda foto y hacia la derecha vuelve a la primera. Cuenta sólo un gesto de más de 30 px y
       más horizontal que vertical; el scroll vertical sigue siendo del navegador (touch-action: pan-y, que al tomarlo
       corta el gesto con pointercancel) y un toque sin deslizar sigue llevando a la ficha */
    /** @type {{ media: Element, x: number, y: number } | null} */
    let swipe = null;
    document.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'touch' || !event.isPrimary) return;
      const media = event.target instanceof Element ? event.target.closest('[data-bm-card-swipe]') : null;
      swipe = media ? { media, x: event.clientX, y: event.clientY } : null;
    });
    document.addEventListener('pointercancel', () => {
      swipe = null;
    });
    document.addEventListener('pointerup', (event) => {
      if (!swipe || event.pointerType !== 'touch') return;
      const { media, x, y } = swipe;
      swipe = null;
      const dx = event.clientX - x;
      const dy = event.clientY - y;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      const card = media.closest('.bm-card');
      if (!(card instanceof HTMLElement)) return;
      card.dataset.bmPhoto = dx < 0 ? '2' : '1';
      /* Si el navegador igual dispara el clic al soltar sobre el enlace de la foto, no se va a la ficha */
      const block = (/** @type {Event} */ click) => {
        click.preventDefault();
        click.stopPropagation();
      };
      media.addEventListener('click', block, { capture: true, once: true });
      setTimeout(() => media.removeEventListener('click', block, { capture: true }), 400);
    });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  if (!customElements.get('bm-recommendations')) {
    class BmRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-loaded') || !this.dataset.url) return;
        // Se pide al conectar, sin esperar a que entre en la vista: en Horizon el scroll vive en .page-wrapper
        // y una captura de página completa (o un salto con Fin) no siempre dispara el observer a tiempo.
        this.load();
      }

      async load() {
        this.setAttribute('data-loaded', '');
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error(String(response.status));
          const fresh = parse(await response.text()).querySelector('bm-recommendations');
          if (fresh && fresh.querySelector('[data-bm-item]')) {
            this.innerHTML = fresh.innerHTML;
            return;
          }
        } catch (error) {
          console.warn('bm-recommendations', error);
        }
        // Sin recomendaciones (catálogo sin publicar o sin historial): la sección no se dibuja
        this.hidden = true;
      }
    }
    customElements.define('bm-recommendations', BmRecommendations);
  }

  if (!customElements.get('bm-recently-viewed')) {
    class BmRecentlyViewed extends HTMLElement {
      connectedCallback() {
        const current = this.dataset.current;
        const limit = Number(this.dataset.limit) || 8;
        const stored = this.read();
        const handles = stored.filter((handle) => handle && handle !== current).slice(0, limit);
        if (current) this.write([current, ...stored.filter((handle) => handle !== current)].slice(0, 20));
        this.render(handles);
      }

      read() {
        try {
          const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
          return Array.isArray(value) ? value : [];
        } catch {
          return [];
        }
      }

      write(handles) {
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
        } catch {
          /* modo privado sin almacenamiento */
        }
      }

      async render(handles) {
        const list = this.querySelector('[data-bm-list]');
        if (!list || handles.length === 0) return this.setEmpty(true);

        const root = this.dataset.root || '';
        const results = await Promise.all(
          handles.map((handle) =>
            fetch(`${root}/products/${encodeURIComponent(handle)}?section_id=${this.dataset.sectionId}`)
              .then(async (response) => ({ status: response.status, html: response.ok ? await response.text() : '' }))
              .catch(() => ({ status: 0, html: '' }))
          )
        );

        /* Sólo salen de la lista los productos que ya no existen (despublicados o borrados): un 404 o, como pasa con
           section_id, un 200 con la sección dibujada sin producto (sin <template data-bm-card>). Un error de red, del
           servidor o un 429 no borra productos vistos: quedan para la próxima visita (QA recomendados-21) */
        /** @type {Set<string>} */
        const gone = new Set();
        let shown = 0;
        for (const [index, { status, html }] of results.entries()) {
          const doc = html ? parse(html) : null;
          const template = doc?.querySelector('template[data-bm-card]');
          if (template) {
            list.append(document.importNode(template.content, true));
            shown += 1;
          } else if (status === 404 || doc?.querySelector('bm-recently-viewed')) {
            gone.add(handles[index]);
          }
        }

        // Se parte de lo guardado, no de lo pedido: así tampoco se pierden los que pasan del límite de la sección
        if (gone.size) this.write(this.read().filter((handle) => !gone.has(handle)));
        this.setEmpty(shown === 0);
        this.querySelector('bm-scroller')?.update?.();
      }

      /* Sin productos vistos la sección no se dibuja: ni título ni espacio (Rosario, Asana 1219793085405339).
         Llega oculta desde Liquid y se muestra sólo con cards. En el editor de temas queda a la vista con el
         aviso de vacío, para poder elegirla. */
      setEmpty(empty) {
        this.toggleAttribute('data-empty', empty);
        this.hidden = empty && !window.Shopify?.designMode;
      }
    }
    customElements.define('bm-recently-viewed', BmRecentlyViewed);
  }
})();
